import { REDUCER_KEY_RS } from '@Pages/RetroSynthesis/RetroSynthesisProjects/constants';
import { REDUCER_KEY_RS_EXPORT } from '@Pages/RetroSynthesis/ExportRoute/constants';

export const rsState = (state) => state && state.get && state.get(REDUCER_KEY_RS);
export const exportState = (state) => rsState(state).get(REDUCER_KEY_RS_EXPORT);
export const exportDialogIsShown = (state) => exportState(state).exportDialogIsShown;
export const isLoading = (state) => exportState(state).isLoading;
export const response = (state) => exportState(state).response;
export const tabs = (state) => {
  const resp = response(state);
  return resp && resp.tabs;
};
